import React, { lazy, Suspense, useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import * as urls from "../utils/URLConst";
import toastNotify from "../utils/ToastNotify";
import makeRequest from "../utils/makeRequest";
import AddNewVenderModal from "../componants/modal/Other Reminder/AddNewVenderModal";
import DeleteConfirmationModal from "../componants/modal/DeleteConfirmationModal";
import RenewalConfirmationModal from "../componants/modal/Other Reminder/RenewalConfirmationModal";
import { Button, Card } from "react-bootstrap";
import Loader from "../componants/loader/Loader";
import { handleLoader } from "../redux/reducers/layout";
import { useDispatch } from "react-redux";
import { BiHomeAlt, BiPlus } from "react-icons/bi";

const ReminderTbl = lazy(() => import('../contants/tables/ReminderTbl'));

const OtherReminder = () => {
  const [addNewVenderModal, setAddNewVenderModal] = useState(false);
  const [apidata, setApiData] = useState([]);
  const [tranCodeData, setTranCodeData] = useState(null);
  const [deleteConfirmationModal, setDeleteConfirmationModal] = useState(false);
  const [deleteRecord, setDeleteRecord] = useState();
  const [renewalConfirmationModal, setRenewalConfirmationModal] = useState(false);
  const [currentEndDate, setCurrentEndDate] = useState();
  const dispatch = useDispatch();

  const openRenewalConfirmationModal = () => {
    setRenewalConfirmationModal(true);
  };

  const openDeleteConfirmationModal = (row) => {
    setDeleteRecord(row);
    setDeleteConfirmationModal(true);
  };

  const openAddNewVenderModal = () => {
    setAddNewVenderModal(!addNewVenderModal);
  };

  async function fetchClientVenderDetail() {
    try {
      dispatch(handleLoader(true));
      const data = {
        FLAG: "A",
      };
      const result = await makeRequest("POST", urls.getClientVeder, data, {});
      if (result.STATUS === "0") {
        const response = result.RESPONSE;
        setApiData(response);
      } else {
        setApiData([]);
        result.MESSAGE !== "Not found!" && toastNotify(result.MESSAGE, "error");
      }
    } catch (error) {
      // Ignore Case
    } finally {
      dispatch(handleLoader(false));
    }
  }

  async function RowDeleteReminder(val) {
    try {
      dispatch(handleLoader(true));
      const config = {};
      var payload = {
        VENDOR_TRAN_CD: val.TRAN_CD,
      };

      const result = await makeRequest(
        "POST",
        urls.setDeleteVender,
        payload,
        config
      );

      if (result.STATUS === "0") {
        toastNotify(result.MESSAGE, "success");
        fetchClientVenderDetail();
        setDeleteConfirmationModal(false);
      } else {
        toastNotify(result.MESSAGE, "error");
      }
    } catch (error) {
      // Ignore Case
    } finally {
      dispatch(handleLoader(false));
    }
  }

  useEffect(() => {
    fetchClientVenderDetail();
  }, []);

  const handleEdit = (row) => {
    setTranCodeData(row);
    openAddNewVenderModal()
  }

  const handleRenewal = (row) => {
    setCurrentEndDate(row.END_DT);
    setTranCodeData(row);
    openRenewalConfirmationModal()
  }

  return (
    <>
      <div className="container-xxl flex-grow-1 container-p-y">
        <div className="row date-time container-top">
          <div className="col-lg-6 col-md-6 col-6">
            <div className="pb-2">
              <span className="d-none d-md-inline"><BiHomeAlt />&nbsp;</span>
              <NavLink to="/dashboard" className="text-secondary d-none d-md-inline">
                Dashboard /
              </NavLink>
              <span className="navigation-header-text ps-1">
                Other Reminder
              </span>
            </div>
          </div>
          <div className="col-lg-6 col-md-6 col-6">
            <div className="pb-2 text-end">
              <Button
                type="button"
                variant="primary"
                className="btn-sm"
                onClick={() => {
                  openAddNewVenderModal();
                }}
              >
                <BiPlus className="me-2" />
                Add Reminder
              </Button>
            </div>
          </div>
        </div>

        <div className="mt-2">
          <Card>
            <Card.Body>
              <Suspense fallback={<Loader isLoader={true} />}>
                <ReminderTbl
                  data={apidata}
                  handleEdit={handleEdit}
                  deleteConfimation={openDeleteConfirmationModal}
                  handleRenewal={handleRenewal}
                />
              </Suspense>
            </Card.Body>
          </Card>
        </div>
      </div >

      {addNewVenderModal && (
        <AddNewVenderModal
          isOpen={addNewVenderModal}
          handleReminder={openAddNewVenderModal}
          fetchClientVenderDetail={fetchClientVenderDetail}
          editedData={tranCodeData}
          setTranCodeData={setTranCodeData}
        />
      )
      }

      {
        renewalConfirmationModal && (
          <RenewalConfirmationModal
            Title={"Renewal Confirmation!"}
            Message={
              "Are you sure you want to renew this record for the next 'One Year'?"
            }
            setRenewalConfirmationModal={setRenewalConfirmationModal}
            fetchClientVenderDetail={fetchClientVenderDetail}
            renewalConfirmationModal={renewalConfirmationModal}
            currentEndDate={currentEndDate}
            tranCodeData={tranCodeData}
          />
        )
      }

      {
        deleteConfirmationModal && (
          <DeleteConfirmationModal
            Title={"Delete Confirmation!"}
            Message={"Do you want to delete this record ?"}
            deleteConfirmationModal={deleteConfirmationModal}
            setDeleteConfirmationModal={setDeleteConfirmationModal}
            deleteRow={() => {
              RowDeleteReminder(deleteRecord);
            }}
          />
        )
      }
    </>
  );
};

export default OtherReminder;
